module.exports = __webpack_public_path__ + "static/media/waste_force_circle.daa3324b.svg";